module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_zigbang.c1f7ee03b26e1f02f5192dc188bfff83.png";